import { combineReducers } from 'redux'
import {survey, favorites, order, songlist, form, refine, bookmark, credentials} from './components/reducers.js'
const rootReducer = combineReducers({
  survey, favorites, order, songlist, form, refine, bookmark, credentials
})
 
export default rootReducer
